import { track } from "@amplitude/analytics-react-native";
import { useCallback } from "react";
import { View } from "react-native";
import RoundedButton from "src/components/RoundedButton";
import haptic from "src/helpers/haptic";
import { paddingLarge, paddingXL } from "src/styles/spacing";
import { useSafeArea } from "src/swsh-native";
import useGatheringFilterSortStore from "../hooks/useGatheringFilterSortStore";

const GatheringFilterSortFooter = () => {
	const safeArea = useSafeArea();
	const apply = useGatheringFilterSortStore((state) => state.apply);
	const reset = useGatheringFilterSortStore((state) => state.reset);
	const closeModal = useGatheringFilterSortStore((state) => state.closeSelf);
	const getAllFilterSortSelections = useGatheringFilterSortStore(
		(state) => state.getAllFilterSortSelections,
	);

	const handlePressReset = useCallback(() => {
		track("gathering_filterSort_reset");
		haptic("Light");
		reset();
	}, [reset]);

	const handlePressApply = useCallback(() => {
		haptic("Medium");
		apply(getAllFilterSortSelections());
		closeModal();
	}, [apply, getAllFilterSortSelections, closeModal]);

	return (
		<View
			style={{
				flexDirection: "row",
				width: "100%",
				paddingTop: paddingLarge,
				paddingBottom: paddingLarge + safeArea.bottom,
				paddingHorizontal: paddingXL,
				justifyContent: "space-around",
				alignItems: "center",
				columnGap: paddingLarge,
			}}
		>
			<RoundedButton
				testID="FilterSort-Reset"
				sizeVariant="Medium"
				colorVariant="Hollow"
				onPress={handlePressReset}
			>
				Reset all
			</RoundedButton>
			<RoundedButton
				testID="FilterSort-Apply"
				sizeVariant="Medium"
				onPress={handlePressApply}
			>
				Apply
			</RoundedButton>
		</View>
	);
};

export default GatheringFilterSortFooter;
